import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-light-green-button',
  templateUrl: './light-green-button.component.html',
  styleUrls: ['./light-green-button.component.css'],
})
export class LightGreenButtonComponent {
  @Input() label: string;
  @Output() click = new EventEmitter<void>();
  @Input() width: String = '140px';
  @Input() height: String = '45px';
  @Input() radius: string = '23px';
  @Input() styles: string | object;
  @Input() buttonType: string = 'button';

  onClick() {
    this.click.emit();
  }
}
